module.exports = __webpack_public_path__ + "img/page_down.452049f0.svg";